import styled from "styled-components";
// @media(min-width: 1024px) - Desk
export const SignupContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 40px;
  justify-content: center;
  @media (min-width: 1024px) {
    transition: ease all 0.5s;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    padding-left: 0;
  }
  padding-right: 40px;
`;
export const HeaderContainer = styled.div`
  transition: ease all 0.5s;
  @media (min-width: 1024px) {
    display: none;
  }
`;

export const ImgBg = styled.div`
  display: none;
  @media (min-width: 1024px) {
    display: block;
    width: 0;
    & img {
      height: 100vh;
      opacity: 0.8;
    }
  }
`;

export const Container = styled.div`
  @media (min-width: 1024px) {
    width: 40%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  h2 {
    font-family: AvertaPE;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: 0.15px;

    align-self: flex-start;

    text-align: start;

    color: #1b2852;
    margin-top: 13px;
  }
`;

export const LogoContainer = styled.div`
  padding-top: 64px;
`;

export const InputsContainer = styled.div`
  padding-top: 47px;
`;

export const ContainerValidations = styled.div`
  margin-top: 16px;
  margin-left: -10px;
`;
